import { render } from "./BilletDetails.vue?vue&type=template&id=0fa9c79e"
import script from "./BilletDetails.vue?vue&type=script&lang=js"
export * from "./BilletDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__